import React from 'react';

interface DownloadIconProps {
  readonly width?: string;
  readonly height?: string;
}

export const NewDownloadIcon = ({width, height}: DownloadIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.47 14.46C12.49 18.67 12.41 18.67 12 18.67C11.57 18.67 11.52 18.67 7.48 14.43L8.48 13.52C9.49 14.61 10.58 15.75 11.34 16.52V2H12.62V16.55C13.1903 15.9328 13.9496 15.14 14.608 14.4526C14.931 14.1153 15.2298 13.8034 15.47 13.55L16.47 14.46ZM19.67 20.67V18.02H21V20.84C21 21.1494 20.8764 21.446 20.6567 21.6638C20.437 21.8816 20.1394 22.0027 19.83 22H4.17C3.86062 22.0027 3.56299 21.8816 3.34328 21.6638C3.12357 21.446 2.99999 21.1494 3 20.84V18.02H4.33V20.67H19.67Z"
        fill="#001E50"
      />
    </svg>
  );
};
